export default function () {
    const headerShipment = document.querySelector('.cart-shipment');

    function calculateShipment() {
        const freeShipmentValue = parseFloat(headerShipment.getAttribute('data-free-shipment-value'));
        const currentPaymentValue = parseFloat(document.querySelector('#cart-box > span').getAttribute('data-current-payment-value'));
        const diff = +(freeShipmentValue - currentPaymentValue).toFixed(2);

        const progressBar = document.querySelector(".shipment-bar .bar-inner");
        let percentage = +(currentPaymentValue / freeShipmentValue).toFixed(1) * 100;
        progressBar.style.width = `${percentage}%`;

        if (diff > 0) {
            headerShipment.innerHTML = `Pozostała kwota do darmowej wysyłki <b class='on'>${diff.toFixed(2).replace('.', ',')} zł</b>`;
            progressBar.style.backgroundColor = '#BBA53D';
        } else {
            headerShipment.innerHTML = `<b class="on">Wysyłka gratis!</b>`;
            progressBar.style.backgroundColor = '#38AA30';
        }
    }

    if (headerShipment) {
        calculateShipment();
    }
}